import {

    GET_MODA_INVOICE_UPDATE_REQUEST,
    GET_MODA_INVOICE_UPDATE_SUCCESS,
    GET_MODA_INVOICE_UPDATE_ERROR,
    UPDATE_MODA_INVOICE_UPDATE_REQUEST,
    UPDATE_MODA_INVOICE_UPDATE_SUCCESS,
    UPDATE_MODA_INVOICE_UPDATE_ERROR,
} from "./types.js";
import moment from "moment";
import { BASEURL } from "../../constant/config.js";
const axios = require("axios");


export const getModaInvoiceUpdate = (token, values) => (dispatch) => {
    dispatch({ type: GET_MODA_INVOICE_UPDATE_REQUEST });

    const data = {
        from_date: moment(values.fromDate).format("MM-DD-YYYY"),
        to_date: moment(values.toDate).format("MM-DD-YYYY"),
        customer_id: values.customer === undefined ? null : values.customer,
    };


    return axios({
        method: "POST",
        url: `${BASEURL}getAll/ExternalInvoiceInfo`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: data
    }).then((response) => {
        return dispatch({
            type: GET_MODA_INVOICE_UPDATE_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: GET_MODA_INVOICE_UPDATE_ERROR,
            payload: error.response,
        });
    });
};

export const updateModaInvoiceUpdate = (token, data) => (dispatch) => {
    dispatch({ type: UPDATE_MODA_INVOICE_UPDATE_REQUEST });

    // const data = {
    //     from_date: moment(values.fromDate).format("MM-DD-YYYY"),
    //     to_date: moment(values.toDate).format("MM-DD-YYYY"),
    //     customer_id: values.customer === undefined ? null : values.customer,
    // };


    return axios({
        method: "PUT",
        url: `${BASEURL}update/UpdateExternalInvoice/123`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
        data: { invoices: data }
    }).then((response) => {
        return dispatch({
            type: UPDATE_MODA_INVOICE_UPDATE_SUCCESS,
            payload: response?.data,
        });
    }).catch((error) => {
        return dispatch({
            type: UPDATE_MODA_INVOICE_UPDATE_ERROR,
            payload: error.response,
        });
    });
};

